import axios from 'axios';
import QS from 'qs';
import store from '../store/index'
import { Message, MessageBox } from 'element-ui'
// 环境的切换
/* if (process.env.NODE_ENV == 'development') {   //开发环境
    axios.defaults.baseURL = 'http://139.196.26.92:8085';
} else if (process.env.NODE_ENV == 'debug') {    //测试环境
    axios.defaults.baseURL = 'http://139.196.26.92:8085';
} else if (process.env.NODE_ENV == 'production') {  //生产环境  
    axios.defaults.baseURL = 'https://ln.freelinkcn.com';
} */
const service = axios.create({
    //  baseURL: process.env.VUE_APP_BASE_API, //URL地址   环境变量文件 .env.development
      timeout: 50000 ,//超时
     // withCredentials: true,  //跨域时若要发生cookie,需要设置该选项
  })


// post请求头
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
service.interceptors.request.use(    
    config => {

         console.log('的值===>>>',config);
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = JSON.parse(window.sessionStorage.getItem('token'));        
        token && (config.headers.Authorization = token);        
        return config;    
    },    
    error => {        
        return Promise.error(error);    
    })

   /*  service.interceptors.request.use(
        config => {
       console.log('的值===>>>',config);
       
          //Access-Control-Allow-Headers: Authorization
            if(window.sessionStorage.getItem('token')){
              config.headers['Authorization'] =  `Bearer ${window.sessionStorage.getItem('token')}`
              // config.headers['token']=JSON.parse(window.sessionStorage.getItem('token'))
           }
            return config;
            
        },
        error => {
            return Promise.reject(error)
        }
        
    ) */
    
    // 相应拦截
    axios.interceptors.response.use(
        // 通过自定义code 判定响应状态 也可以通过HTTP状态码判断
        response =>{
            const res = response.data    
                /* if(res.code == 2 ){
                    // 重新登陆
                    MessageBox.confirm(
                        '登陆状态异常,请重新登陆',
                        "确认登陆信息",
                        {
                            confirmButtonText: '重新登陆',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }
                    ).then(()=>{
                      window.sessionStorage.clear()
                     router.push('/login')
                       
                    })
                } */
                return res;
       
        },
        /*  */
        error =>{
          if (error.response) {
            switch (error.response.status) {
              case 404:
                Message.error('资源开小差')
                break
              case 500:
                Message.error('服务器报错')
                break
              default:
                Message.error(error.response.statusText)
            }
          } else {
            // 请求超时或者网络有问题
            if (error.message.includes('timeout')) {
              Message.error('请求超时！请检查网络是否正常')
            } else {
              Message.error('请求失败，请检查网络是否已连接')
            }
          }
          return Promise.reject(error)
        }
    
    )

    export default {
        post (url, data,headers) {
          return service({
            method: 'post',
            url,
            data: data,
            headers:headers
          })
        },
        get (url, params,headers) {

            console.log('url, params,header的值===>>>',url, params,headers
            );
            
            return service({
              method: 'get',
              url,
              params,
              headers:headers
            })
          },
    
    
    
    
    }




// WEBPACK FOOTER //
// ./src/request/http.js